
const actions = {

  SET_CURRENT_APP: 'SET_CURRENT_APP',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SET_COUNTRY_CODE: 'SET_COUNTRY_CODE',

  searchTermUpdated(searchTerm){
    return {
      type: actions.SET_SEARCH_TERM,
      searchTerm,
    }
  },

  appSelected: ( app, secondApp) => {
    console.log( ' app action', app, secondApp);
    return({
      type: actions.SET_CURRENT_APP,
      app,
      secondApp
    })
  },
  
  countryCodeUpdated: (countryCode) => {
    return({
      type: actions.SET_COUNTRY_CODE,
      countryCode
    })
  }

// searchTermUpdated: searchTerm => ({
//   type: actions.SET_SEARCH_TERM,
//   searchTerm,
// })
  
};
export default actions;
  


// WEBPACK FOOTER //
// ./src/redux/itunesSearch/actions.js